/* src/app/dynamic-forms/form-view/form-view-action/form-view-action.component.css */
.mat-mdc-form-field {
  display: inline;
}
/*# sourceMappingURL=form-view-action.component.css.map */
